module.exports = __webpack_public_path__ + "img/IMG_1899_L_BlackMatted.2677863d.jpg";